(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["voucher"] && !Shopify.designMode) return;
  try {
    
// Initialize the carousel
document.addEventListener('DOMContentLoaded', function() {
  new Splide('#coupons-carousel', {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '15px',
    pagination: false,
    breakpoints: {
      1024: {
        perPage: 3,
      },
      768: {
        perPage: 2,
      },
      480: {
        perPage: 1,
      }
    }
  }).mount();
});

window.applyDiscountCode = function (code) {
  const spinner = document.getElementById('loading-spinner');
  const popup = document.getElementById('coupon-popup');
  const messageContainer = document.querySelector('.popup-message');

  // Show the spinner
  spinner.classList.remove('hidden');

  // Create and send the AJAX request
  fetch(`/discount/${code}`, { method: 'GET' })
    .then(response => {
      if (response.ok) {
        messageContainer.textContent = "Your discount has been successfully applied!";
      } else {
        throw new Error("Failed to apply discount.");
      }
      popup.classList.remove('hidden');
    })
    .catch(error => {
      messageContainer.textContent = "Something went wrong. Please try again.";
      popup.classList.remove('hidden');
    })
    .finally(() => {
      // Hide the spinner after the request is complete
      spinner.classList.add('hidden');
    });
};

window.closePopup = function () {
  document.getElementById('coupon-popup').classList.add('hidden');
};

  } catch(e) { console.error(e); }
})();
})();
